import React from 'react';
import styled from 'styled-components';
import {LeagueStanding} from 'app/components/standings/LeagueStanding';
import StandingsHeader from 'app/components/standings/StandingsHeader';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const CupTable = ({standings}) => {
  return (
    <Container>
      <StandingsHeader />
      <LeagueStanding standings={standings} gameType='cup' />
    </Container>
  );
};

export default CupTable;
